import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { API_URL } from "../config";

function LoginPage({ onLogin }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!login || !password) {
      setError("Login i hasło są wymagane");
      return;
    }
    try {
      setLoading(true);
      const response = await fetch(
        `${API_URL}/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ login, password }),
        }
      );
      if (!response.ok) throw new Error("Błędny login lub hasło");
      const data = await response.json();
      const user = data.user;

      if (rememberMe) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      onLogin(user);
      navigate("/dashboard");
    } catch (err) {
      console.error("Błąd logowania:", err);
      setError(err.message || "Nie udało się zalogować.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="login">
      <div className="login__card">
        <header className="login__header">
          <h1>Logowanie</h1>
          <p>Zaloguj się, aby przejść do panelu.</p>
        </header>

        {error && (
          <div className="login__alert" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login__form">
          <label>
            Login
            <input
              type="text"
              placeholder="Wpisz login"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label className="password-field">
            Hasło
            <div className="password-field__wrap">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Wpisz hasło"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((s) => !s)}
                aria-label={showPassword ? "Ukryj hasło" : "Pokaż hasło"}
              >
                {showPassword ? "Ukryj" : "Pokaż"}
              </button>
            </div>
          </label>

          <label className="remember">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Zapamiętaj Mnie</span>
          </label>

          <button type="submit" className="login__submit" disabled={loading}>
            {loading ? "Logowanie…" : "Zaloguj się"}
          </button>

          <div className="login__helpers">
            <a href="/kontakt">Problemy z logowaniem? Skontaktuj się z nami</a>
          </div>
        </form>
      </div>
    </section>
  );
}

export default LoginPage;
